import { render } from "./Loading.vue?vue&type=template&id=efe9d588"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=efe9d588&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Loading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "efe9d588"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('efe9d588', __exports__)) {
    api.reload('efe9d588', __exports__)
  }
  
  module.hot.accept("./Loading.vue?vue&type=template&id=efe9d588", () => {
    api.rerender('efe9d588', render)
  })

}


export default __exports__